// Versión de la app = CACHE_NAME de public/sw.js, inyectada por Vite en el
// build (ver vite.config.ts). NO se edita a mano: el sw.js es la única fuente.
export const APP_VERSION: string = __APP_VERSION__;
